import React, { useState } from 'react';
import { X, MessageSquare, Zap, CheckCircle2 } from 'lucide-react';

const TopUpModal = ({ isOpen, onClose, onConfirm, loading }) => {
  const [messageCount, setMessageCount] = useState(5000);
  
  if (!isOpen) return null;

  const topUpOptions = [
    { count: 1000, price: 500, label: 'Starter Pack' },
    { count: 5000, price: 2000, label: 'Value Pack', popular: true },
    { count: 10000, price: 3500, label: 'Growth Pack' },
    { count: 25000, price: 7500, label: 'Professional' },
  ];

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-fade-in">
      <div className="bg-white w-full max-w-lg rounded-3xl shadow-2xl overflow-hidden animate-slide-up">
        <div className="px-8 py-6 flex items-center justify-between border-b border-gray-100">
          <div>
            <h2 className="text-xl font-black text-gray-900">Message Top-up</h2>
            <p className="text-xs text-gray-500 font-bold mt-0.5">Instant credits for your organization</p>
          </div>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
          >
            <X className="h-5 w-5 text-gray-400" />
          </button>
        </div>

        <div className="p-8">
          <div className="grid grid-cols-2 gap-4 mb-8">
            {topUpOptions.map((option) => (
              <button
                key={option.count}
                onClick={() => setMessageCount(option.count)}
                className={`relative p-5 rounded-2xl border-2 transition-all flex flex-col items-center text-center ${
                  messageCount === option.count
                  ? 'border-primary-600 bg-primary-50/50'
                  : 'border-gray-100 hover:border-primary-100'
                }`}
              >
                {option.popular && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary-600 text-white px-2 py-0.5 rounded-full text-[8px] font-black uppercase tracking-wider">
                    Popular
                  </span>
                )}
                {messageCount === option.count && (
                  <CheckCircle2 className="absolute top-2 right-2 h-4 w-4 text-primary-600" />
                )}
                <div className="p-2 bg-white rounded-lg shadow-sm border border-gray-50 mb-3">
                   <MessageSquare className={`h-4 w-4 ${messageCount === option.count ? 'text-primary-600' : 'text-gray-400'}`} />
                </div>
                <span className="text-sm font-black text-gray-900">{option.count.toLocaleString()}</span>
                <span className="text-[10px] font-bold text-gray-500 uppercase tracking-tighter mb-2">{option.label}</span>
                <span className="text-sm font-black text-primary-600">₹{option.price}</span>
              </button>
            ))}
          </div>

          <div className="bg-gray-50 rounded-2xl p-5 mb-8">
            <div className="flex justify-between items-center mb-1">
              <span className="text-xs font-bold text-gray-500 uppercase">Selected Package</span>
              <span className="text-xs font-black text-gray-900">{messageCount.toLocaleString()} Messages</span>
            </div>
            <div className="flex justify-between items-center pt-3 border-t border-gray-200">
               <span className="text-sm font-black text-gray-900">Total Amount</span>
               <span className="text-lg font-black text-primary-600">₹{topUpOptions.find(o => o.count === messageCount)?.price}</span>
            </div>
          </div>

          <button
            onClick={() => onConfirm(messageCount)}
            disabled={loading}
            className="w-full py-4 bg-primary-600 hover:bg-primary-700 text-white rounded-2xl text-xs font-black uppercase tracking-widest shadow-lg shadow-primary-100 transition-all flex items-center justify-center gap-2"
          >
            {loading ? (
               <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <>
                <Zap className="h-4 w-4" />
                Confirm & Top-up
              </>
            )}
          </button>
          
          <p className="text-[10px] text-gray-400 text-center mt-4 font-medium px-4">
            Messages will be added instantly after payment. No hidden charges.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TopUpModal;
